<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M8.5 0.75C8.5 0.335786 8.16421 0 7.75 0C7.33579 0 7 0.335786 7 0.75V7H0.75C0.335786 7 0 7.33579 0 7.75C0 8.16421 0.335786 8.5 0.75 8.5H7V14.75C7 15.1642 7.33579 15.5 7.75 15.5C8.16421 15.5 8.5 15.1642 8.5 14.75V8.5H14.75C15.1642 8.5 15.5 8.16421 15.5 7.75C15.5 7.33579 15.1642 7 14.75 7H8.5V0.75Z" />
  </svg>
</template>
